import { useState } from 'react'
import { styled } from 'styled-components'
import FileUploader from '../../FileUploader'
import getClassListDownloadUrl from '../../../libs/download-service'

interface StudentUploadModalProps {
    classId: number
    onClose: () => void
    onConfirm: () => void
}

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`

const ModalContent = styled.div`
    background-color: #ffffff;
    border-radius: 12px;
    padding: 32px;
    width: 90%;
    max-width: 500px;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
`

const ModalTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    margin: 0 0 20px 0;
`

const ModalDescription = styled.p`
    font-size: 14px;
    color: #666666;
    margin: 0 0 20px 0;
    line-height: 1.5;
`

const DownloadSection = styled.div`
    border: 1px solid #e5e6eb;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 20px;
    background-color: #f9f9f9;
`

const DownloadLabel = styled.p`
    font-size: 13px;
    font-weight: 600;
    color: #333333;
    margin: 0 0 12px 0;
`

const DownloadLink = styled.a`
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    background-color: #1fa474;
    color: #ffffff;
    text-decoration: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;

    &:hover {
        background-color: #188c5f;
    }
`

const UploadSection = styled.div`
    border: 1px solid #e5e6eb;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 20px;
`

const UploadLabel = styled.p`
    font-size: 13px;
    font-weight: 600;
    color: #333333;
    margin: 0 0 12px 0;
`

const ModalButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
`

const CancelButton = styled.button`
    padding: 10px 24px;
    background-color: #f2f3f5;
    color: #333333;
    border: 1px solid #e5e6eb;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #e5e6eb;
    }
`

const ConfirmButton = styled.button`
    padding: 10px 24px;
    background-color: #1fa474;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #188c5f;
    }
`

export default function StudentUploadModal({
    classId,
    onClose,
    onConfirm,
}: StudentUploadModalProps) {
    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalTitle>Upload Students</ModalTitle>
                <ModalDescription>
                    Download the template file and fill in your student
                    information, then upload it to add students to this class.
                </ModalDescription>

                <DownloadSection>
                    <DownloadLabel>Step 1: Download Template</DownloadLabel>
                    <DownloadLink href={getClassListDownloadUrl()} download>
                        Download Student Template
                    </DownloadLink>
                </DownloadSection>

                <UploadSection>
                    <UploadLabel>Step 2: Upload Completed File</UploadLabel>
                    <FileUploader classId={classId} />
                </UploadSection>

                <ModalButtonGroup>
                    <CancelButton onClick={onClose}>Close</CancelButton>
                    <ConfirmButton onClick={onConfirm}>Done</ConfirmButton>
                </ModalButtonGroup>
            </ModalContent>
        </ModalOverlay>
    )
}
